<template>
  <div
    v-click-outside="onClose"
    class="select"
    :class="getClasses"
  >
    <div
      class="preview"
      @click="onToggle"
    >
      <span>
        {{ placeholder }}
      </span>
      <div class="arrow">
        <svg viewBox="0 0 8 5" xmlns="http://www.w3.org/2000/svg"><path d="M4 5L0 0H8L4 5Z" fill="currentColor"/></svg>
      </div>
    </div>

    <div
      v-show="isActive"
      class="options"
    >
      <div
        v-for="option of options"
        :key="option.value"
        class="option"
        :class="getOptionClasses(option)"
        @click="onChoose(option)"
      >
        {{ option.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  directives: {
    clickOutside: {
      beforeMount (el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event, el)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unmounted (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  props: {
    modelValue: {
      default: null
    },
    /* [{value: '', text: ''}] */
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'primary',
      validator: v => ['primary', 'gold'].includes(v)
    }
  },
  data () {
    return {
      isActive: false,
      current: this.modelValue
    }
  },
  computed: {
    getClasses () {
      return {
        select_active: this.isActive,
        select_disabled: this.disabled,
        [`select_theme-${this.theme}`]: true
      }
    },
    placeholder () {
      const activeItem = this.options.find(i => i.value === this.current)
      const result = activeItem ? activeItem.text : 'Выберите из списка'
      return result
    }
  },
  watch: {
    modelValue (newValue) {
      this.current = newValue
    }
  },
  methods: {
    onToggle () {
      this.isActive = !this.isActive
    },
    onClose () {
      this.isActive = false
    },
    getOptionClasses (optionData) {
      return {
        option_active: this.current === optionData.value,
        option_disabled: optionData.disabled
      }
    },
    onChoose (optionData) {
      const { value } = optionData

      this.current = value
      this.$emit('update:modelValue', value)
      this.onClose()
    }
  }
}
</script>

<style lang="scss" scoped>
$disabled-color:              #b7b7b7;
$brand-color:                 #FF7A00 !important;

.select {
  height: 42px;
  position: relative;
  user-select: none;

  &_theme-primary {
    .preview {
      color: #fff;
      background: #242428;
      border-radius: 5px;

      .arrow {
        color: $brand-color;
      }
    }

    .options {
      .option {
        &_active {
          background: #D3E9FF;
        }
      }
    }
  }

  &_active {
    .arrow {
      transform: rotate(180deg);
    }
  }

  &_disabled {
    pointer-events: none;

    .preview {
      border-color: $disabled-color !important;
      color: $disabled-color !important;
    }
  }

  .preview {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 0 16px;
    font-weight: 500;

    .arrow {
      display: flex;
      align-items: center;
      width: 12px;
      background-repeat: no-repeat;
      background-size: 100%;
      transition: .2s;
    }
  }

  .options {
    position: absolute;
    bottom: 0;
    transform: translateY(100%);
    width: 100%;
    max-height: 250px;
    overflow: auto;
    background: #fff;
    z-index: 1;

    .option {
      padding: 12px 8px;
      cursor: pointer;
      color: #000;

      &:not(.option_active):hover {
        background: #F2F5F9;
      }

      //&_active {
      //  background: #D3E9FF;
      //}

      &_disabled {
        pointer-events: none;
        background: #e3e3e3;
        color: $disabled-color;
      }
    }
  }
}
</style>
